import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	repositoryPrefix: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.summary-cell.repository-prefix',
		defaultMessage: 'Repository',
		description:
			'Prefixes a link to an SCM repository, describing that the link is to a repository',
	},
});
